import { getDateWhenString } from "common/date-utils";
export const filterByMostRecentDate = () => (args, d) => {
    if (!args.context) {
        args.context = {};
    }
    if (!args.context.mostRecentDate) {
        args.context.mostRecentDate = new Date(Math.max(...args.visitable.map((s) => getDateWhenString(s.date)?.getTime() || 0)));
    }
    return (getDateWhenString(d.date)?.getTime() || 0) === (args.context.mostRecentDate?.getTime() || 0);
};
